import { useQuery } from '@tanstack/react-query'

import { getHasListings } from '@/ports'

const fetchHasListings = async (): Promise<any> => {
  const response = await getHasListings()
  return response?.body
}

export const useHasListings = (): any => {
  const { data: hasListings, isLoading } = useQuery(
    [`has-listings`],
    () => fetchHasListings(),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60000
    }
  )
  return { hasListings, isLoading }
}
